import { LogsService } from './LogsService';

export const logsService = new LogsService();
